<template>
  <div>
    <label
      v-if="title"
      class="snui-label"
      :style="`color: ${titleColor}`"
      :for="labelFor"
      v-html="title"
    />
    <span
      v-if="optional"
      class="snui-label optional-label"
    >
      (Optional)
    </span>
  </div>
</template>

<script>

export default {
  name: 'SnLabel',
  props: {
    title: {
      type: String,
      default: '',
      required: false
    },
    optional: {
      type: Boolean,
      default: false,
      required: false
    },
    titleColor: {
      type: String,
      default: '#1F1F1F',
      required: false
    },
    labelFor: {
      type: String,
      default: '',
      required: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~/assets/css/snui/index.scss';

.snui-label {
  font-family: $font-family-primary !important;
  font-size: 17px;
  font-weight: 400;
  line-height: 24px;
}

.optional-label {
  color: #BFBFBF;
}

</style>
